import { theme } from '@prophecy/theme';
import { Badges } from '@prophecy/ui-v3/Badges';
import { Stack } from '@prophecy/ui-v3/Layout';
import { Text } from '@prophecy/ui-v3/Typography';
import { compactNumber } from '@prophecy/utils/number';

export function SQLPipelineObservationLayout({
  title,
  count,
  children
}: {
  children: React.ReactNode;
  title: string;
  count: number;
}) {
  return (
    <Stack gap={theme.spaces.x32} height='100%'>
      <Stack direction='horizontal' gap={theme.spaces.x12} alignY='center'>
        <Text level='lg'>{title}</Text>
        {count > 0 && <Badges tone='gray'>{compactNumber(count)}</Badges>}
      </Stack>
      <Stack gap={theme.spaces.x24} grow='1'>
        {children}
      </Stack>
    </Stack>
  );
}
